import React from 'react';
import { Header, Grid, List } from 'semantic-ui-react';
import { MenuConsumer } from '../../../FoodMenu.context';
import MenuUtil from '../../../utils/menu';
import { ItemContainer } from '../item';

const CategoryColumn = ({ categoryId }) => {
  return (
    <MenuConsumer>
      {({ categories, items }) => {
        const category = MenuUtil.getCategoryById(categories, categoryId);
        const { items: categoryItemIds } = category;
        const categoryItems = MenuUtil.getCategoryItems(categoryItemIds, items);
        const { name, description } = category;

        return (
          <Grid.Column id={name}>
            <Header as="h3" icon style={{ textAlign: 'left' }}>
              {name}
              <Header.Subheader style={{ marginTop: '10px' }}>{description}</Header.Subheader>
            </Header>
            <div style={{ padding: '0.75rem 2.5% 0 2.5%' }}>
              <List>
                {categoryItems.map(({ _id }) => (
                  <ItemContainer
                    key={_id}
                    itemId={_id}
                    showDescription={false}
                    showModifierSets={false}
                  />
                ))}
              </List>
            </div>
          </Grid.Column>
        );
      }}
    </MenuConsumer>
  );
};

export default CategoryColumn;
